import { CheckIcon as Check, ProhibitIcon as Prohibit, ArrowCounterClockwiseIcon as Reopen, CircleNotchIcon as Spinner } from "@phosphor-icons/react";
import { reopenStateFor } from "@/lib/validationConstants";

/**
 * Validate / Reject / Reopen button group shared by business rules and deliverables.
 * `state` decides which buttons show: open items get Validate + Reject, decided items get Reopen.
 * `compact` renders icon-only buttons for table rows.
 */
export default function DecisionButtons({ state, kind = "rule", onDecide, busy = false, disabled = false, compact = false, testidPrefix = "decision" }) {
  const decided = state === "validated" || state === "rejected";
  const base = compact
    ? "inline-flex items-center gap-1 px-1.5 py-1 text-[10px] border transition-colors disabled:opacity-40"
    : "inline-flex items-center gap-1.5 px-3 py-1.5 text-xs border transition-colors disabled:opacity-40";
  const off = disabled || busy;
  return (
    <div className="inline-flex items-center gap-1" data-testid={`${testidPrefix}-buttons`}>
      {busy && <Spinner size={12} className="animate-spin text-[var(--ml-text-secondary)]" />}
      {!decided && (
        <>
          <button type="button" onClick={() => onDecide("validated")} disabled={off} title="Validate — confirm as consultant-reviewed"
            data-testid={`${testidPrefix}-validate`}
            className={`${base} border-[#a7f0ba] text-[#0e6027] hover:bg-[#defbe6]`}>
            <Check size={12} weight="bold" /> {compact ? "" : "Validate"}
          </button>
          <button type="button" onClick={() => onDecide("rejected")} disabled={off} title="Reject — dismiss as not a real rule / not usable"
            data-testid={`${testidPrefix}-reject`}
            className={`${base} border-[var(--ml-border)] text-[var(--ml-text-secondary)] hover:bg-[var(--ml-surface)]`}>
            <Prohibit size={12} weight="bold" /> {compact ? "" : "Reject"}
          </button>
        </>
      )}
      {decided && (
        <button type="button" onClick={() => onDecide(reopenStateFor(kind))} disabled={off} title="Reopen — back to unreviewed inference"
          data-testid={`${testidPrefix}-reopen`}
          className={`${base} border-[var(--ml-border)] text-[var(--ml-text-secondary)] hover:bg-[var(--ml-surface)]`}>
          <Reopen size={12} weight="bold" /> {compact ? "" : "Reopen"}
        </button>
      )}
    </div>
  );
}
